import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=140d8a35&scoped=true&"
import script from "./AccountList.vue?vue&type=script&lang=js&"
export * from "./AccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d8a35",
  null
  
)

export default component.exports